import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  subTitle: {
    id: 'signinPage.subTitle',
    defaultMessage: 'gives you focus, from work to play.'
  },
  getStartedButtonText: {
    id: 'signinPage.getStartedButtonText',
    defaultMessage: "Sign in"
  },
  firstTimeSignInHint: {
    id: 'signinPage.firstTimeSignInHint',
    defaultMessage: 'Click here to proceed'
  },
  learnButtonText: {
    id: 'signinPage.learnButtonText',
    defaultMessage: 'Learn more'
  },
  waitText: {
    id: 'signinPage.waitText',
    defaultMessage: 'Please wait...'
  },
});

// Generated by GitHub Copilot | author: Raviteja Madhira | Updated on: 2026-07-21 | 4 lines added | Added firstTimeSignInHint message ("Click Sign In to Proceed") for the embedded pre-handoff sign-in screen

